import { render, staticRenderFns } from "./AvailabilityConfig.vue?vue&type=template&id=2ef02cc6"
import script from "./AvailabilityConfig.vue?vue&type=script&lang=js"
export * from "./AvailabilityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports